import { DateTime } from 'luxon'

/**
 * 選択可能な開始日と最大日付を返す関数
 * @param baseDay 開始基準日
 * @param startOffsetDays 開始日を基準日から何日後にするか
 * @param maxOffsetDays 開始日から何日後にするか
 * @returns { startDate: DateTime, maxDate: DateTime }
 */
export function getSelectableDateRange(baseDay: DateTime, startOffsetDays: number, maxOffsetDays: number) {
  const startDate = baseDay.plus({ days: startOffsetDays }).startOf('day')
  const maxDate = startDate.plus({ days: maxOffsetDays }).endOf('day')

  return { startDate, maxDate }
}

/** X（旧Twitter）募集の公開希望日上限: 2026年4月30日 23:59:59.999（Asia/Tokyo） */
export function getJstEndOfApril30Year2026(): DateTime {
  return DateTime.fromObject({ year: 2026, month: 4, day: 30 }, { zone: 'Asia/Tokyo' }).endOf('day')
}
